module.exports = __webpack_public_path__ + "static/media/blind-destiny-mp.d4a7abf7.gif";